import React from 'react';
import './Modal.css';

const AboutModal = ({ onClose }) => {
  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">About</h4>
          </div>
          <div className="modal-body">
            The demo is developed under the MIMBCD-UI Project.
            <a href="https://mimbcd-ui.github.io/" target="_blank" rel="noreferrer">Click here to learn more about the MIMBCD-UI Project</a>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
